//Сообщение для служебных утилит
export default {
  panel: {
    e_no_settings: "Параметры настройки панели отображения данных отсутствуют!\nОбратитесь к администратору системы.",
    e_error_values: "Параметр панель отображения данных имеет неизвестное значение!\nОбратитесь к администратору системы."
  }
}
